import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  attributeName: 'appPackage',
  isDragable: false,
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: false,
  isSelectable: true,
  isMultiSelectable: false,
  getURL: 'appId/appPackage',
  sessionParams: ['appId'],
  emptyMessage: "You don't have providers, go to virtual ticket section to create one.",
  fields: [
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: false,
      canCreate: false,
      width: "20rem",
      canFilter: true,
      helpText: 'Name of the virtual ticket provider.',
    },
    {
      attributeName: 'sportRoomName',
      label: 'Sport Room',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: false,
      canCreate: false,
      canFilter: true,
      helpText: 'Name of the virtual ticket provider.',
    },
    {
      attributeName: 'type',
      label: 'Type',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      width: "15rem",
      canEdit: false,
      canCreate: false,
      default: '',
      helpText: 'Type of virtual ticket provider.',
      canFilter: true,
      canOrder: false,
    },
  ],
};
